import type { SVGProps } from 'react'

const SvgDelete = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    className={className}
    height="1em"
    viewBox="0 0 18 18"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      height={18}
      id="delete_svg__a"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'alpha' }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" fill="inherit" />
    </mask>
    <g mask="url(#delete_svg__a)">
      <path
        d="M5.2 15.902q-.708 0-1.207-.498a1.64 1.64 0 0 1-.499-1.208V4.55h-.853V2.843h4.006V1.99h4.697v.853h4.015v1.706h-.853v9.647q0 .71-.5 1.207a1.64 1.64 0 0 1-1.207.5zM12.8 4.55H5.2v9.647h7.6zm-6.13 8.197h1.602v-6.75H6.67zm3.058 0h1.603v-6.75H9.728z"
        fill="inherit"
      />
    </g>
  </svg>
)

export default SvgDelete
